var render = function render(){var _vm=this,_c=_vm._self._c;return _c('country-flag',{staticClass:"flag-icon",attrs:{"rounded":_vm.rounded,"size":_vm.size,"country":_vm.isoName.toLowerCase()}})
}
var staticRenderFns = []

export { render, staticRenderFns }